import { render } from "./AutoSystemClassificationResultsTable.vue?vue&type=template&id=3181b628&scoped=true&ts=true"
import script from "./AutoSystemClassificationResultsTable.vue?vue&type=script&lang=ts"
export * from "./AutoSystemClassificationResultsTable.vue?vue&type=script&lang=ts"

import "./AutoSystemClassificationResultsTable.vue?vue&type=style&index=0&id=3181b628&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3181b628"]])

export default __exports__